import styled from "@emotion/styled"
import { getMediaQueryMin, spacingStaticLg, spacingStaticMd } from "@porsche-design-system/components-react/emotion"
import type { PropsWithChildren, ReactNode } from "react"
import { ContentWrapper } from "../contentWrapper/ContentWrapper"

interface StageListWithSidePanelProps extends PropsWithChildren {
	belowStickyHeader?: boolean
	sidePanel?: ReactNode
}

export const StageListWithSidePanel = ({ children, sidePanel }: StageListWithSidePanelProps) => (
	<Layout>
		<ContentColumn>{children}</ContentColumn>
		{sidePanel !== undefined && <SidePanelColumn>{sidePanel}</SidePanelColumn>}
	</Layout>
)

const Layout = styled(ContentWrapper)`
	display: flex;
	flex-direction: column-reverse;
	gap: ${spacingStaticMd};
	align-items: stretch;
	padding-top: ${spacingStaticMd};
	padding-bottom: ${spacingStaticMd};

	${getMediaQueryMin("m")} {
		flex-direction: row;
		align-items: flex-start;
	    gap: ${spacingStaticLg};
	}
`

const ContentColumn = styled.div`
	flex: 3;
	min-width: 0;
	display: flex;
	flex-direction: column;
	gap: ${spacingStaticMd};
`

const SidePanelColumn = styled.aside`
	padding: 0 ${spacingStaticLg};

	${getMediaQueryMin("m")} {
		padding: 0;
		flex: 1;
		min-width: 0;
		position: sticky;
		top: 116px; /* spacingStaticMd + 100px for height of sticky header */
	}
`
